import dayjs from "dayjs";
import { updateBasketBar } from "./basket-bar/updateBasketBar";
import { hasV2Basket, initAddToBasketV2, initAddToBasketV2Bulk, setBasketExpiryTimer } from "./basket-v2";
import { getBasketData } from "./basket-v2/api/getBasketData";
import { renderBasketPageV2 } from "./basket-v2/renderBasketPageV2";
import { updateDropdownsFromServer } from "./basket-v2/updateDropdownsFromServer";
import { constants } from "./common";
import { getEventBasketType } from "./common/getEventBasketType";
import { isBasketPage } from "./common/isBasketPage";

export async function initTicketing(): Promise<void> {
  // Can we get this to check the basket type for the page instead?

  await initBasketV2();

  if (isBasketPage()) {
    await renderBasketPageV2();
  } else if (getEventBasketType() === "v2") {
    initAddToBasketV2();
    initAddToBasketV2Bulk();
    await updateDropdownsFromServer();
  }
}

async function initBasketV2(): Promise<void> {
  if (!(await hasV2Basket())) {
    return;
  }

  const { data } = await getBasketData();

  if (!data) {
    handleMissingBasket();
    return;
  }

  const { checkoutUrl, total, totalItems, basketUrl, expiryTime } = data;
  const url = isBasketPage() ? checkoutUrl : basketUrl;

  setBasketExpiryTimer(dayjs(expiryTime), url);
  updateBasketBar({
    total,
    totalItems,
    checkoutUrl: url,
  });
  //await updateDropdownsFromServer();
}

function removeStoredExpiry(storageKey: string): void {
  try {
    window.localStorage.removeItem(storageKey);
  } catch {
    console.warn("Failed to remove stored expiry time from localStorage.");
  }
}

function handleMissingBasket(): void {
  const storageKey = constants.defaults.basketExpiryTimeLocalStorageKey;
  let storedExpiryTime: string | null = null;

  try {
    storedExpiryTime = window.localStorage.getItem(storageKey);
  } catch {
    console.warn("Failed to read stored expiry time from localStorage.");
    return;
  }

  if (!storedExpiryTime) {
    return;
  }

  if (dayjs(storedExpiryTime).isAfter(dayjs())) {
    removeStoredExpiry(storageKey);
    return;
  }

  if (!isBasketPage()) {
    return;
  }

  removeStoredExpiry(storageKey);

  const basketUrl = new URL(window.location.href);
  if (basketUrl.searchParams.get("status") === "expired") {
    return;
  }

  // Update the URL without reloading to avoid a second loading state
  basketUrl.searchParams.set("status", "expired");
  window.history.replaceState(null, "", basketUrl.toString());
}
